export const ROUTES = {
  admin: "/admin",
  auth: "/auth",
  destinations: "/destinations",
};
